module.exports = __webpack_public_path__ + "trianglesRepeating.c6f2972c155d5177c7cccdc48a31f622.png";